<template>
  <NavigationComponent>
    <Standardfolie title="Ordnerstruktur">
      <VCode
        content="public/
├── favicon.ico
└── index.html
src/
├── assets
│   └── logo.png
├── components
│   └── Standardfolie.vue
├── plugins
│   └── vuetify.js
├── router
│   └── index.js
├── store
│   └── index.js
├── views
│   └── Einführung.vue
|
├── App.vue
└── main.js"
      >
      </VCode>
    </Standardfolie>
  </NavigationComponent>
</template>

<script>
import NavigationComponent from "../components/NavigationComponent";
import Standardfolie from "../components/Standardfolie";
import VCode from "../components/VCode";
export default {
  name: "Ordnerstruktur",
  components: { Standardfolie, NavigationComponent, VCode }
};
</script>

<style scoped></style>
